import styled from '@emotion/styled';

import { ReactComponent as Cup } from '@icons/pencil-paintings/cup.svg';
import { ReactComponent as Globe } from '@icons/pencil-paintings/globe.svg';
import { ReactComponent as NotGood } from '@icons/pencil-paintings/not-good.svg';
import { ReactComponent as NotInterested } from '@icons/pencil-paintings/not-interested.svg';
import { ReactComponent as Women } from '@icons/pencil-paintings/women.svg';
import { illustrationsBase } from '@styles/mixins/illustrations';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const StyledNotGood = styled(NotGood)`
  ${illustrationsBase}
  left: 225px;
  bottom: 310px;

  ${getMediaqueryStyled('xl')} {
    width: 233px;
  }

  ${getMediaqueryStyled('lg')} {
    left: 145px;
    bottom: 145px;
    width: 139px;
  }

  ${getMediaqueryStyled('md')} {
    left: 15px;
    bottom: 185px;
  }

  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

export const StyledWomen = styled(Women)`
  ${illustrationsBase}
  left: 245px;
  bottom: 175px;

  ${getMediaqueryStyled('xl')} {
    left: 270px;
    bottom: 180px;
    width: 91px;
  }

  ${getMediaqueryStyled('lg')} {
    left: 155px;
    bottom: 75px;
    width: 54px;
  }

  ${getMediaqueryStyled('md')} {
    left: 25px;
    bottom: 115px;
  }

  ${getMediaqueryStyled('sm')} {
    left: 33px;
    bottom: 108px;
    width: 65px;
  }
`;

export const StyledCup = styled(Cup)`
  ${illustrationsBase}
  left: 655px;
  bottom: 100px;

  ${getMediaqueryStyled('xl')} {
    left: 595px;
    bottom: 100px;
  }

  ${getMediaqueryStyled('lg')} {
    left: 365px;
    bottom: 35px;
    width: 118px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const StyledNotInterested = styled(NotInterested)`
  ${illustrationsBase}
  right: 555px;
  bottom: 390px;

  ${getMediaqueryStyled('xl')} {
    right: 425px;
    bottom: 405px;
    width: 220px;
  }

  ${getMediaqueryStyled('lg')} {
    right: 295px;
    bottom: 185px;
    width: 128px;
  }

  ${getMediaqueryStyled('md')} {
    right: 210px;
    bottom: 160px;
  }

  ${getMediaqueryStyled('sm')} {
    right: 130px;
    bottom: 155px;
    width: 123px;
  }
`;

export const StyledGlobe = styled(Globe)`
  ${illustrationsBase}
  right: 135px;
  bottom: 215px;

  ${getMediaqueryStyled('xl')} {
    right: 55px;
    bottom: 250px;
    width: 308px;
  }

  ${getMediaqueryStyled('lg')} {
    right: 80px;
    bottom: 95px;
    width: 179px;
  }

  ${getMediaqueryStyled('md')} {
    right: 0;
    bottom: 80px;
    width: 167px;
  }

  ${getMediaqueryStyled('sm')} {
    right: -3px;
    width: 120px;
  }
`;
